<!--
 * @FileDescription: 单一数据名称与数据或多个组合展示
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-09-07 15:43:37
 -->
<template>
    <!-- <dv-border-box13 v-if="keyValId == '1'" class="keyVal-template" :order="order" :keyValId="keyValId"
        :nameValListAll="nameValListAll">
        <el-carousel height="100%" indicator-position="none" :autoplay="false" class="keyVal-carousel" ref="keyValCarousel">
            <el-carousel-item v-for="itemFir in nameValListAll" :key="itemFir">
                <div class="data-title">{{ title }}</div>
                <div class="key-val" v-for="item in itemFir" :key="item.name">
                    <div class="key-name">{{ item.name }}</div>
                    <div class="val-content">{{ item.val }}</div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </dv-border-box13> -->
    <dv-border-box13 v-if="keyValId == '1'" class="keyVal-template" :order="order" :keyValId="keyValId"
        :nameValListA="nameValListA">
        <div class="data-title">{{ title }}</div>
        <div class="key-val" v-for="nameVal in nameValListA" :key="nameVal.name">
            <div class="key-name">{{ nameVal.name }}</div>
            <div class="val-content">{{ nameVal.val }}</div>
        </div>
    </dv-border-box13>

    <dv-border-box13 v-else-if="keyValId == '2'" class="keyVal-template" :order="order" :keyValId="keyValId">
        <div class="data-title">{{ title }}</div>
        <div class="key-val" v-for="nameVal in nameValList" :key="nameVal.name">
            <div class="key-name">{{ nameVal.name }}</div>
            <div class="val-content">{{ nameVal.val }}</div>
        </div>
    </dv-border-box13>
</template>
<!-- <template>
    <dv-border-box13 class="keyVal-template" :order="order" :keyValId="keyValId">
        <div class="data-title">{{ title }}</div>
        <div class="key-val" v-for="nameVal in nameValList" :key="nameVal.name">
            <div class="key-name">{{ nameVal.name }}</div>
            <div class="val-content">{{ nameVal.val }}</div>
        </div>
    </dv-border-box13>
</template> -->

<script>
export default {
    name: 'KeyValTemplate',
    data() {
        return {
            // nameKeyValAll: [],
        }
    },
    mounted() {
        // let nameKeyValAll = this.$parent.nameValListAll
        // this.nameKeyValAll = window.parent.nameValListAll
        // console.log("nameKeyValAll",window.parent.nameValListAll);
    },
}
</script>


<script setup>
// import { toRefs } from 'vue';
import { defineProps } from 'vue';
import { BorderBox13 as DvBorderBox13 } from '@kjgl77/datav-vue3'

let props = defineProps({
    keyValId: String,
    order: String,
    title: String,
    nameValList: Array,
    nameValListAll: Array,
    nameValListA: Array
});
console.log("KeyValprops", props)

// let keyValList = refProps.nameValListAll._object.nameValListAll
// console.log("refProps", refProps.nameValListAll._object.nameValListAll);

// let keyValList = props.nameValListAll
// console.log("refProps", refProps.nameValListAll._object.nameValListAll);

// const order = props.order;

// let nameKeyValAll = window.parent.nameValListAll
// console.log("nameKeyValAll",nameKeyValAll);

</script>


<style lang="scss" scoped>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.keyVal-template {
    position: relative;
    display: flex;
    flex-flow: row wrap;


    &[keyValId='1'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 28vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            // column-gap: 5%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: calc(0.3vh + 1vw);
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            // height: fit-content;
            // width: 28w;
            height: 8vh;
            row-gap: 0vh;
            // align-content: center;
            justify-content: center;
            align-items: center;
            display: flex;
            flex-flow: column nowrap;

            div.key-name {
                height: 4vh;
                line-height: 4vh;
                font-size: calc(0.3vh + 0.8vw);
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: center;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                height: 4h;
                line-height: 4vh;
                font-size: calc(0.3vh + 0.8vw);
                text-align: center;
                font-family: "Impact";
                color: rgb(97, 247, 255);
            }
        }




    }

    &[keyValId='2'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 20vw;
        height: 12vh;
        z-index: 12;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 9%;
            background-color: rgba(255, 255, 255, 0.1);
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: calc(0.2vh + 1vw);
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: 9vh;
            row-gap: 0vh;
            justify-content: center;

            div.key-name {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                height: 4.5vh;
                line-height: 4.5vh;
                font-size: calc(0.3vh + 0.8vw);
                text-align: right;
                font-family: "Impact";
                color: rgb(181, 255, 97);
            }
        }
    }

    &[keyValId='3'] {
        margin-top: 1vh;
        margin-left: 1vw;
        width: 20vw;
        height: 12vh;

        div.border-box-content {
            width: 98%;
            // margin-left: 2%;
            column-gap: 9%;
        }

        div.data-title {
            // margin-top: 0.4vh;
            width: 28vw;
            line-height: 3vh;
            height: 3vh;
            font-size: 1vw;
            font-weight: 600;
            color: rgba(230, 242, 252, 0.9);
        }

        div.key-val {
            width: fit-content;
            height: fit-content;
            row-gap: 1vh;
            justify-content: flex-start;

            div.key-name {
                font-size: 1.8vh;
                font-weight: 600;
                font-family: "Microsoft YaHei";
                text-align: right;
                color: rgb(246, 251, 255);
            }

            div.val-content {
                font-size: 2.6vh;
                text-align: right;
                font-family: "Impact";
                color: rgb(181, 255, 97);
            }
        }
    }

    @each $order in $orders {
        &[order='#{$order}'] {
            order: $order;
        }
    }

    // div.border-box-content {
    //     display: flex;
    //     flex-flow: row wrap;
    //     justify-content: center;
    //     align-content: center;
    // }


    // div.data-title {
    //     position: relative;
    //     font-family: "Microsoft YaHei";
    //     text-align: center;
    // }



    // div.key-val {
    //     display: flex;
    // flex-flow: column wrap;
    //     align-items: center;

    // div.key-name {
    //     width: 100%;

    // }

    // div.val-content {
    //     width: 100%;
    // }
    // }
}
</style>
